import env from "react-dotenv";
import { isString } from "lodash";
import { loginRequest } from "app/auth/authConfig";

let endpoints = null;
let token = null;
let _msalInstance = null;
let msalStorageKey = null;

export async function getEndpoints(name) {
    if (endpoints === null) {
        console.log("Endpoints - Can't get endpoint config", name);
        return;
    }
    return endpoints.find((config) => config.name === name);
}

export async function setEndpoints() {
    let i = Math.floor(Math.random() * 1000000);

    const response = await fetch("/endpoints.json?i=" + i);

    endpoints = response.status === 204
        ? null
        : await response.json();

    return endpoints;
}

export async function getMicrosoftSecurityToken(msalInstance) {

    if (msalInstance) {
        _msalInstance = msalInstance;
    }

    let now = new Date();
    let microsoftTokenExpirationDate = getMicrosoftTokenExpirationDate();
    let account = _msalInstance.getAllAccounts()[0];

    const tokenRequest = {
        ...loginRequest,
        scopes: [env.BESTWORK_REACT_AZUREAD_SCOPE],
        account: account,
    };

    let refresh = false;
    let refreshTokenDate = getMicrosoftTokenRefreshDate();

    if (refreshTokenDate !== null && now.getTime() >= refreshTokenDate) {
        redirectLogin();
    }

    if (microsoftTokenExpirationDate !== null && now.getTime() >= microsoftTokenExpirationDate) {
        refresh = true;
    }

    if (token === null || refresh) {

        try {
            const tokenResponse = await _msalInstance.acquireTokenSilent(tokenRequest);
            const now = new Date();
            token = tokenResponse.accessToken;
            let refreshDate = now.getTime() + 12 * 60 * 60 * 1000;
            localStorage.setItem("usrsesref", refreshDate);

        } catch (_error) {
            console.error(_error, "Error acquiring microsoft access token");
            token = null;
        }
    }

    if (token !== null && getSessionCacheItems().length === 0) {
        token = null;
        redirectLogin();
    }

    return token;
}

export async function clearToken() {
    token = null;
    localStorage.removeItem("usrsesref");
    localStorage.removeItem("VPNAlert");
    sessionStorage.removeItem("securityToken");
}

function getMicrosoftTokenRefreshDate() {
    let rv = null;
    let tokenInfo = localStorage.getItem("usrsesref");

    if (tokenInfo !== null) {
        rv = tokenInfo;
    }
    return rv;
}

function parseLocalStorageEntry(key, data) {
    let dataValue = null;

    try {
        dataValue = JSON.parse(data);
    }
    catch { }

    if (!dataValue?.expiresOn || !dataValue?.clientId) {
        return null;
    }

    let tokenExpiration = dataValue.expiresOn;

    if (isString(tokenExpiration)) {
        tokenExpiration = Number.parseInt(tokenExpiration);
    }

    if (key.length > 20) {
        msalStorageKey = key.substring(0, 20);
    }

    if (dataValue.clientId === env.BESTWORK_REACT_AZUREAD_CLIENT_ID) {
        return tokenExpiration * 1000;
    }

    return null;
}

function getMicrosoftTokenExpirationDate() {
    let microsoftTokenExpirationDate = null;

    for (const key of Object.keys(localStorage)) {
        const data = localStorage.getItem(key);

        if (!data) {
            continue;

        }

        const expiration = parseLocalStorageEntry(key, data);

        if (expiration !== null) {
            microsoftTokenExpirationDate = expiration;
        }
    }

    return microsoftTokenExpirationDate;
}

function getSessionCacheItems() {
    let keys = [];

    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).substring(0, 20) === msalStorageKey) {
            keys.push(localStorage.key(i));
        }
    }
    return keys;
}

function redirectLogin() {
    localStorage.setItem("sessionExpired", true);
    let keys = getSessionCacheItems();

    for (const key of keys) {
        localStorage.removeItem(key);
    }

    localStorage.removeItem("usrsesref");
    localStorage.removeItem("VPNAlert");
    sessionStorage.removeItem("securityToken");
    globalThis.location.replace("/");
}

export function getMSALInstance() {
    return _msalInstance;
}

export async function clearCacheItems() {
    const names = await caches.keys();
    names.forEach((name) => {
        console.log("CACHE", name);
        caches.delete(name);
    });
}
